import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=03d5f0f2&"
import script from "./ResetPassword.vue?vue&type=script&lang=js&"
export * from "./ResetPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03d5f0f2')) {
      api.createRecord('03d5f0f2', component.options)
    } else {
      api.reload('03d5f0f2', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=03d5f0f2&", function () {
      api.rerender('03d5f0f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/auth/ResetPassword.vue"
export default component.exports